import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Select } from '~/eds/src/components/Select/Select';
import { OperatorId } from '~/evifields/src/types/OperatorId';
import { LabeledOperator } from '~/features/advanced-search/types';
import { Nullable } from '~/types/Nullable';

interface Props {
  isEmbedded?: boolean;
  operators: LabeledOperator[];
  value: Nullable<OperatorId>;
  onChange: (updatedValue: Nullable<OperatorId>) => void;
}

export const OperatorSelect = ({
  isEmbedded,
  operators,
  value,
  onChange,
}: Props) => {
  const intl = useIntl();

  const options = useMemo(
    () =>
      operators.map((operator) => ({
        label: operator.label,
        value: operator.id,
      })),
    [operators],
  );

  return (
    <Select
      enableControl={!isEmbedded}
      enablePortal={true}
      isClearable={false}
      isEmbedded={isEmbedded}
      isSearchable={false}
      isMulti={false}
      name="operator"
      options={options}
      placeholder={intl.formatMessage({
        id: 'OperatorSelect.choosePlaceholder',
        defaultMessage: 'Choose an operator',
        description: 'Placeholder text for operator selection dropdown',
      })}
      value={value}
      onChange={onChange}
    />
  );
};
